<template>
  <section class="full-width-image-section completed-trails gray-bg">
    <div class="container">
      <div class="text-center" style="margin-bottom: 20px">
        <h1 class="trails-header special-header">Notifications</h1>
      </div>

      <Section>
        <div v-if="notifications.length === 0" class="text-center">
          <p>No notifications available.</p>
        </div>

        <div v-else class="row">
          <div
            v-for="notification in notifications"
            :key="notification.NotificationId"
            class="col-md-6 col-lg-4 mb-4"
          >
            <div class="card notification-card">
              <div class="card-body d-flex">
                <!-- Logo/Icon -->
                <img
                  :src="getNotificationIcon(notification.NotificationType)"
                  class="notification-icon"
                  alt="Notification Type"
                />

                <div class="flex-grow-1">
                  <!-- Notification Title -->
                  <h5 class="notification-title">
                    {{ notification.Notification }}
                  </h5>

                  <!-- Date -->
                  <p class="notification-date">
                    {{ formatDate(notification.DatePublished) }}
                  </p>

                  <!-- Status Badge 
                <span :class="getStatusClass(notification.StatusId)">
                  {{ getStatusText(notification.StatusId) }}
                </span>
                --></div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </div>
  </section>

  <!-- REGISTER FOR WALKS FORM - Compoonents-->
  <UserForm />

  <section class="full-width-image-section footer green-sep"></section>
</template>

<script>
import db from "@/db"; // Import IndexedDB
import UserForm from "@/components/Userform.vue";
export default {
  components: {
    UserForm,
  },
  data() {
    return {
      notifications: [],
    };
  },
  async mounted() {
    await this.fetchNotifications();
  },
  methods: {
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    async fetchNotifications() {
      try {
        const customerId = localStorage.getItem("tenantId");
        const base64Credentials = btoa("Ian:Ennistymon1!");
        const baseURL = process.env.VUE_APP_API_BASE_URL;
        const url = `${baseURL}VisitorCard/GetNotifications`;

        // Set timeout to avoid long hangs
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000);

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            CustomerId: customerId,
            Authorization: `Basic ${base64Credentials}`,
          },
          signal: controller.signal,
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error("Failed to fetch notifications.");
        }

        const notificationsData = await response.json();
        this.notifications = notificationsData.slice(0, 20); // Limit to 20 notifications

        // Save notifications to IndexedDB
        if (db.tables.find(table => table.name === "notifications")) {
          await db.notifications.clear();
          await db.notifications.bulkPut(notificationsData);
        }
      } catch (error) {
        console.warn(
          "Fetching notifications failed, loading offline data:",
          error
        );
        this.notifications = await db.notifications.toArray(); // Fallback to local data
      }
    },

    getNotificationIcon(type) {
      const icons = {
        1: "/img/icons/exclamation-triangle-solid.png",
        2: "/img/icons/comment-dots-solid.png",
      };
      return icons[type] || "/img/icons/wicklow_120.png"; // Default icon
    },

    getStatusClass(statusId) {
      return {
        "badge bg-success": statusId === 1,
        "badge bg-warning": statusId === 2,
        "badge bg-danger": statusId === 3,
      };
    },

    getStatusText(statusId) {
      return (
        {
          1: "Active",
          2: "In Progress",
          3: "Expired",
        }[statusId] || "Unknown"
      );
    },
  },
};
</script>

<style>
.notifications-section {
  padding: 40px 0;
}

.notification-card {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
}

.notification-card:hover {
  transform: scale(1.02);
}

.notification-icon {
  width: 50px;
  height: 50px;
  margin-right: 15px;
  align-self: center;
}

.notification-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}

.notification-date {
  font-size: 14px;
  color: #777;
}

.badge {
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 20px;
}
</style>
